// ** React Imports

// ** Custom Components
import Block from "components/layout/Block";
import Heading from "components/typography/Heading";

// #####################################################

export const UserpanelSection = ({
	headingText,
	headingType = "h3",
	children,
}) => {
	return (
		<Block>
			{headingText && (
				<Block mb={3}>
					<Heading type={headingType}>{headingText}</Heading>
				</Block>
			)}

			<Block flex full column withRowGap>
				{children}
			</Block>
		</Block>
	);
};
